var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewModule = function SvgViewModule(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_module",
    clipPath: "url(#clip0_3301_2320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.08317 16.0416H11.3332C12.1123 16.0416 12.7498 15.3854 12.7498 14.5833V8.74996C12.7498 7.94788 12.1123 7.29163 11.3332 7.29163H7.08317C6.304 7.29163 5.6665 7.94788 5.6665 8.74996V14.5833C5.6665 15.3854 6.304 16.0416 7.08317 16.0416ZM7.08317 26.25H11.3332C12.1123 26.25 12.7498 25.5937 12.7498 24.7916V18.9583C12.7498 18.1562 12.1123 17.5 11.3332 17.5H7.08317C6.304 17.5 5.6665 18.1562 5.6665 18.9583V24.7916C5.6665 25.5937 6.304 26.25 7.08317 26.25ZM15.5832 26.25H19.8332C20.6123 26.25 21.2498 25.5937 21.2498 24.7916V18.9583C21.2498 18.1562 20.6123 17.5 19.8332 17.5H15.5832C14.804 17.5 14.1665 18.1562 14.1665 18.9583V24.7916C14.1665 25.5937 14.804 26.25 15.5832 26.25ZM24.0832 26.25H28.3332C29.1123 26.25 29.7498 25.5937 29.7498 24.7916V18.9583C29.7498 18.1562 29.1123 17.5 28.3332 17.5H24.0832C23.304 17.5 22.6665 18.1562 22.6665 18.9583V24.7916C22.6665 25.5937 23.304 26.25 24.0832 26.25ZM15.5832 16.0416H19.8332C20.6123 16.0416 21.2498 15.3854 21.2498 14.5833V8.74996C21.2498 7.94788 20.6123 7.29163 19.8332 7.29163H15.5832C14.804 7.29163 14.1665 7.94788 14.1665 8.74996V14.5833C14.1665 15.3854 14.804 16.0416 15.5832 16.0416ZM22.6665 8.74996V14.5833C22.6665 15.3854 23.304 16.0416 24.0832 16.0416H28.3332C29.1123 16.0416 29.7498 15.3854 29.7498 14.5833V8.74996C29.7498 7.94788 29.1123 7.29163 28.3332 7.29163H24.0832C23.304 7.29163 22.6665 7.94788 22.6665 8.74996Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3301_2320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 35,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewModule, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view_module.edff0ee9.svg";
export { ForwardRef as ReactComponent };